
import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  Inject,
  DOCUMENT
} from '@angular/core';

@Component({
  standalone: true,
  selector: 'ngx-json-ld',
  template: '',
})
export class JsonLdShimComponent implements OnChanges {
  @Input() json: object | null = null;

  private scriptEl: HTMLScriptElement | null = null;

  constructor(@Inject(DOCUMENT) private doc: Document) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['json']) {
      return;
    }
    if (this.scriptEl?.parentNode) {
      this.scriptEl.parentNode.removeChild(this.scriptEl);
      this.scriptEl = null;
    }
    if (!this.json) {
      return;
    }
    const s = this.doc.createElement('script');
    s.type = 'application/ld+json';
    s.text = JSON.stringify(this.json);
    this.doc.head.appendChild(s);
    this.scriptEl = s;
  }
}
